export default __webpack_public_path__ + "static/media/up.20b47be1.svg";